export default "__VITE_PUBLIC_ASSET__aa785eba__"